import react from 'react';

function Dashboard() {
    return (<>
        <h1>Bioworld Admin</h1>
    </>)
}

export default Dashboard;